import React, { useEffect, useCallback, useState } from "react";
import NotificationAlert from "react-notification-alert";
import { t } from 'react-multi-lang';
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { fetchReporting, fetchAllreporting, reportingLigneGetById, deleteReporting } from "../../../Redux/reportingReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import SweetAlert from "react-bootstrap-sweetalert";

// FullCalendar imports
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';


function ListReporting({ client }) {
  document.title = "Liste des reportings";
  const dispatch = useDispatch();
  const navigate = useHistory();
  const notificationAlertRef = React.useRef(null);
  const [entities, setEntities] = useState([]);
  const [loader, setLoader] = useState(true);
  const lang = window.localStorage.getItem("lang");
  const annee = localStorage.getItem("annee");
  const [alert, setAlert] = React.useState(null);

  const notify = (place, msg, type) => {
    var options = {
      place: place,
      message: (<div>{msg}</div>),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  function ajouter() {
    navigate.push(client + '/ajouterReporting');
  }

  const name = "listereporting";
  const currentDate = new Date();
  const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  const fileName = `${name} ${formattedDate}`;
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

const exportToexcel = async (info) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    if (!info || info.length === 0) {
        return;
    }

    // Add headers
    const headers = Object.keys(info[0]);
    worksheet.addRow(headers);

    // Style header (optional but nice)
    worksheet.getRow(1).font = { bold: true };

    // Add rows
    info.forEach((item) => {
        worksheet.addRow(Object.values(item));
    });

    // Auto width columns
    worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
            const length = cell.value ? cell.value.toString().length : 10;
            if (length > maxLength) {
                maxLength = length;
            }
        });
        column.width = maxLength + 2;
    });

    // Generate buffer
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
};


  const handleEdit = (id) => {
    navigate.push(`${client}/reporting/update/${id}`);
  };

  const getinfo = useCallback(async () => {
    const root = await dispatch(fetchAllreporting({ client, annee }));
    exportToexcel(root.payload.arrayreporting);
  }, [dispatch, client, annee]);

  const getLigne = useCallback(async () => {
    const ligne = await dispatch(fetchReporting({ client, annee }));
    setEntities(ligne.payload);
    setLoader(false);
  }, [dispatch, client, annee]);

  useEffect(() => {
    getLigne();
  }, [getLigne]);

  const onDetailClick = async (eventInfo, e) => {
    e.stopPropagation();
    const { title, start, id } = eventInfo.event;
    const formattedDate = start?.toISOString().split('T')[0];

    try {
      const ligne = await dispatch(reportingLigneGetById(id));
      const activite = ligne.payload;

      // Build HTML table rows
      const tableRows = activite?.map((item, index) => `
      <tr>
        
        <td>${item.activites.nom || ''}</td>
        <td>${item.commentaire || ''}</td>
      </tr>
    `).join('');

      Swal.fire({
        title: title,
        html: `
        <p><strong>Date:</strong> ${formattedDate || '—'}</p>
        <div style="max-height: 300px; overflow-y: auto;">
          <table class="table" style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                
                <th>Activité</th>
                <th>Commentaire</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </div>
      `,
        width: '60%',
        confirmButtonText: 'Fermer',
      });
    } catch (error) {
      Swal.fire('Erreur', 'Impossible de charger les détails.', 'error');
      console.error(error);
    }
  };



  const confirmMessage = (id, idRow) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={"Étes Vous sûr de supprimer ce Relevé?"}
        onConfirm={() => {
          deleteReportingH(id, idRow);
        }}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      ></SweetAlert>
    );
  };

  async function deleteReportingH(id, idRow) {
    try {
      const result = await dispatch(deleteReporting({ id }));

      // Vérifie si la suppression a réussi
      console.log(result.payload)
      if (result?.payload) {
        listeReleve(0, id);
        notify("tr", "Supprimé avec succès", "success");
      } else {
        notify("tr", "Erreur lors de la suppression", "danger");
      }
    } catch (error) {
      console.log(error)
      console.error("Erreur suppression relevé:", error);
      notify("tr", "Erreur inattendue", "danger");
    } finally {
      hideAlert();
    }
  }
  const hideAlert = () => {
    setAlert(null);
  };
  return (
    <>
      <Container fluid>
        {alert}
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              Ajouter reporting
            </Button>
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">
                  Reporting
                  <Button
                    className="btn-export mr-1 float-right"
                    type="button"
                    onClick={getinfo}
                    style={{ cursor: "pointer", fontSize: 14 }}
                  >
                    Exporter Reporting
                  </Button>
                </Card.Title>
              </Card.Header>
              <Card.Body className="calendar-style">
                {!loader && (
                  <FullCalendar
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    locale={lang === "fr" ? "fr" : "en"}
                    events={entities.map((e) => ({
                      title: e.titre,
                      date: e.date,
                      id: e.id,
                      extendedProps: {
                        Description: e.titre || "",
                        Date: e.date || "",

                      }
                    }))}
                    eventContent={(eventInfo) => {
                      const { title, id } = eventInfo.event;

                      return (
                        <div style={{ fontSize: '0.8rem' }}>
                          <b>{title}</b>
                          <div style={{ marginTop: 4 }}>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(id);
                              }}
                              style={{
                                fontSize: '10px',
                                marginRight: '4px',
                                padding: '2px 6px',
                                background: '#ffc107',
                                color: '#000',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                              }}
                            >
                              ✏️
                            </button>
                            <button
                              onClick={(e) => onDetailClick(eventInfo, e)}
                              style={{
                                fontSize: '10px',
                                padding: '2px 6px',
                                background: '#17a2b8',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                              }}
                            >
                              📄 Détail
                            </button>
                            <button
                              onClick={(e) => confirmMessage(id, e)}
                              style={{
                                fontSize: '10px',
                                padding: '2px 6px',
                                background: 'red',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                              }}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </div>
                        </div>
                      );
                    }}

                    dateClick={(info) => {
                      localStorage.setItem('date', info.dateStr);
                      navigate.push(client + '/ajouterReporting');
                    }}

                    height="auto"
                  />

                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListReporting;
